import { mapGetters } from 'vuex';
import { TagColors } from '@/components/tag/tag.enums';
import { ITEMS_PER_PAGE } from '@/services/constants';
import { RnActionHeader, RnNewTable, RnFilters, RnButton, RnNotification, RnIcon, RnPagination, RnAlert, RnTag } from '@/components';

export default {
	name: 'rn-pickup-points-view',
	components: {
		RnActionHeader,
		RnButton,
		RnNotification,
		RnIcon,
		RnPagination,
		RnNewTable,
		RnAlert,
		RnFilters,
	},
	data() {
		return {
			ITEMS_PER_PAGE: ITEMS_PER_PAGE.default,
			page: 0,
		};
	},
	created() {
		this.getPickupPoints();
	},
	computed: {
		...mapGetters(['user', 'locationsByBrand', 'locationsByBrandCount', 'isLoading']),

		pickupPoints() {
			const locationsWithAddress = this.locationsByBrand.map(location => {
				return {
					...location,
					address: `${location.street} ${location.number}, ${location.zipCode} ${location.city}`,
				};
			});

			return locationsWithAddress;
		},

		pickupPointsCount() {
			return this.locationsByBrandCount;
		},
		pupHeaders() {
			return [
				{
					text: this.$t('user.addressInfo.companyName'),
					value: 'businessRelation.name',
				},
				{
					text: this.$t('user.addressInfo.country'),
					value: 'country',
				},
				{
					text: this.$t('user.addressInfo.address'),
					value: 'address',
				},
				{
					text: this.$t('user.contactInfo.status'),
					value: 'active',
					component: RnTag,
					componentProps: value => ({
						text: this.$t(`table.pup.status.${value.active ? 'active' : 'notActive'}`),
						color: TagColors[value.active ? 'active' : 'notActive'],
					}),
				},
			];
		},
	},
	methods: {
		getPickupPoints(page = 0, excel = false) {
			this.page = page;
			// Brand is not sent. POST /locations/search (and /excel) replaces the body
			// on the proxy and sets linkedBrandId from the session (buildPickupPointSearchBody).
			const filters = {
				page: page || 0,
				excel,
			};

			this.$store.dispatch('getLocationsByBrand', filters);
		},
	},
};
